import styled from 'styled-components';

export const Container = styled.div`
  width: auto;
`;

export const Botao = styled.button`
  background: #c358d4;
  color: white;
  padding: 10px;
  border: 0;
  font-weight: bold;
  :hover {
    background: #942ba5;
  }
`;
